import React from 'react';
import { Grid, Box, Typography, Divider, Skeleton } from '@mui/material';
import { DownArrow, GreenUpArrowIcon } from '../../../../assets';
import { useSelector } from 'react-redux';
import { getDifferenceBetweenDateRange } from '../../../../utility';

const DigitalEngagementInfo = () => {
    const { dtcData } = useSelector((state) => state.webMatrix);
    const { isWebMatrixPatientLoading, paidMediaSummary } = dtcData;
    const {
        totalPaidMediaSummary, isPeriodChangeIncrease,periodChange 
    } = paidMediaSummary;
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    
    return (
        <>
            <Grid container spacing={1}>
                <Grid item xs={4}>
                    <Box className="flex-column gap-8">
                        <Box>
                            <Typography className="engagement-title">Paid Media Engagement</Typography>
                        </Box>
                        <Box className="flex-row">
                            <Box>
                                {isWebMatrixPatientLoading? <Skeleton height={30} variant='text' width={60} /> : <Typography className="engagement-value">{totalPaidMediaSummary}</Typography>}
                            </Box>
                            <Box className="flex-column gap-2 center-align ml-5-percent">
                                <Typography className={`text-sm-medium ${isPeriodChangeIncrease ? 'success-700' : 'error-700'}`}>
                                    {isWebMatrixPatientLoading ? (
                                        <Skeleton variant='text' width={100} />
                                    ) : (
                                        <>
                                            {isPeriodChangeIncrease ? <GreenUpArrowIcon /> : <DownArrow />}
                                            {periodChange}
                                        </>
                                    )}
                                </Typography>
                                <Typography className="physicians-engagement-last-year">
                    vs Last {getDifferenceBetweenDateRange(startDateRange, endDateRange)}
                                </Typography>
                            </Box>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
            <Divider className="border-1-gray mb-2 mt-2" />
        </>
    );
};

export default DigitalEngagementInfo;
